import declare from "dojo/_base/declare";
import { PreferenceView } from "csi/prefs/PreferenceView";
import Widget from "csi/table/Widget";

const EC_TYPE = "SpecType";

const AffectedSpecsTable = declare(Widget, {
	/**
	 * @override
	 * Affected Specs Table View to Group by SpecType by default
	 */
	onCreateDefaultCustomView(cv: PreferenceView): void {
		this.inherited(arguments);
		this.setDefaultGroupAndExpand(EC_TYPE);
	},
});

export = AffectedSpecsTable;
